import { Container } from 'theme-ui';
import SectionHeader from '../SectionHeader';
import ProductList from '~/components/Product/List';
type Props = {
  showcase: Queries.GroupFragmentFragment;
  validateChildren: (type: string) => boolean;
};
const ProductShowcase = ({ showcase, validateChildren }: Props) => {
  if (!showcase) return null;
  return (
    <Container
      data-testid="product-showcase"
      as="section"
      variant="fullwidth"
      sx={{
        padding: 0,

        margin: 0,
      }}
    >
      <div sx={{ width: 'content-fit' }}>
        <SectionHeader
          // @ts-ignore - still a jsx file
          productSection={true}
          title={showcase.title || 'OUR MOST POPULAR'}
          forwardSx={{
            width: '100%',
            'h2, h3': { pb: '2.4rem' },
            fontSize: ['2.4rem', '3.2rem'],
            lineHeight: 1.1,
          }}
        />

        <Container variant="customNavContainer" sx={{ py: 0, px: '2.4rem' }}>
          <ProductList spotlights={showcase.spotlights} validateChildren={validateChildren} />
        </Container>
      </div>
    </Container>
  );
};

ProductShowcase.defaultProps = {
  validateChildren: () => true,
};

export default ProductShowcase;
